// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_l9_","rightAdornment":"Header_rightAdornment__2WTNL"};